import React, { useState } from 'react';
import styled from 'styled-components';

const GalleryContainer = styled.div`
  padding: 60px 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
`;

const GalleryTitle = styled.h1`
  text-align: center;
  margin-bottom: 50px;
  color: var(--primary-color);
  font-size: 2.8rem;
`;

const GalleryDescription = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 40px;
  font-size: 1.1rem;
  color: var(--dark-text);
  line-height: 1.6;
`;

const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
`;

const PhotoCard = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
  position: relative;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const PhotoImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: transform 0.5s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const VideoThumbnail = styled.div`
  width: 100%;
  height: 250px;
  position: relative;
  overflow: hidden;
  
  &::after {
    content: '▶️';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3rem;
    color: white;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
`;

const VideoPreview = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  max-width: 90%;
  max-height: 90%;
  position: relative;
`;

const ModalImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  border-radius: 5px;
`;

const ModalVideo = styled.video`
  max-width: 100%;
  max-height: 80vh;
  border-radius: 5px;
  background-color: black;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background-color: transparent;
  color: white;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  
  &:hover {
    color: var(--accent-color);
  }
`;

// Données des photos et vidéos
const mediaItems = [
  {
    id: 1,
    src: '/img/photogalerie/compressed/flo1.jpeg',
    type: 'image'
  },
  {
    id: 3,
    src: '/img/photogalerie/compressed/IMG_0046.jpeg',
    type: 'image'
  },
  {
    id: 4,
    src: '/img/photogalerie/compressed/IMG_0049.jpeg',
    type: 'image'
  },
  {
    id: 5,
    src: '/img/photogalerie/compressed/IMG_0053.jpeg',
    type: 'image'
  },
  {
    id: 6,
    src: '/img/photogalerie/compressed/IMG_0055.jpeg',
    type: 'image'
  },
  {
    id: 7,
    src: '/img/photogalerie/compressed/IMG_0060.jpeg',
    type: 'image'
  },
  {
    id: 8,
    src: '/img/photogalerie/compressed/IMG_0061.jpeg',
    type: 'image'
  },
  {
    id: 9,
    src: '/img/photogalerie/compressed/IMG_0081.jpeg',
    type: 'image'
  },
  {
    id: 10,
    src: '/img/photogalerie/compressed/IMG_0085.jpeg',
    type: 'image'
  },
  {
    id: 11,
    src: '/img/photogalerie/compressed/IMG_0107.jpeg',
    type: 'image'
  },
  {
    id: 12,
    src: '/img/photogalerie/compressed/IMG_0111.jpeg',
    type: 'image'
  },
  {
    id: 13,
    src: '/img/photogalerie/compressed/IMG_0115.jpeg',
    type: 'image'
  },
  {
    id: 14,
    src: '/img/photogalerie/compressed/IMG_0116.jpeg',
    type: 'image'
  },
  {
    id: 15,
    src: '/img/photogalerie/compressed/IMG_0127.jpeg',
    type: 'image'
  },
  {
    id: 16,
    src: '/img/photogalerie/compressed/IMG_0129.jpeg',
    type: 'image'
  },
  {
    id: 17,
    src: '/img/photogalerie/compressed/IMG_0139.jpeg',
    type: 'image'
  },
  {
    id: 18,
    src: '/img/photogalerie/compressed/IMG_0145.jpeg',
    type: 'image'
  },
  {
    id: 19,
    src: '/img/photogalerie/compressed/IMG_0693.jpeg',
    type: 'image'
  },
  {
    id: 20,
    src: '/img/photogalerie/compressed/IMG_1359.jpeg',
    type: 'image'
  },
  {
    id: 21,
    src: '/img/photogalerie/compressed/IMG_20220807_124349.jpeg',
    type: 'image'
  },
  {
    id: 22,
    src: '/img/photogalerie/compressed/IMG_2681.jpeg',
    type: 'image'
  },
  {
    id: 23,
    src: '/img/photogalerie/compressed/IMG_2685.jpeg',
    type: 'image'
  },
  {
    id: 24,
    src: '/img/photogalerie/compressed/IMG_2703.jpeg',
    type: 'image'
  },
  {
    id: 25,
    src: '/img/photogalerie/compressed/IMG_2710.jpeg',
    type: 'image'
  },
  {
    id: 26,
    src: '/img/photogalerie/compressed/IMG_2712.jpeg',
    type: 'image'
  },
  {
    id: 27,
    src: '/img/photogalerie/compressed/IMG_2740.jpeg',
    type: 'image'
  },
  {
    id: 28,
    src: '/img/photogalerie/compressed/IMG_2789.jpeg',
    type: 'image'
  },
  {
    id: 29,
    src: '/img/photogalerie/compressed/IMG_2797.jpeg',
    type: 'image'
  },
  {
    id: 30,
    src: '/img/photogalerie/compressed/IMG_2828.jpeg',
    type: 'image'
  },
  {
    id: 31,
    src: '/img/photogalerie/compressed/IMG_2844.jpeg',
    type: 'image'
  },
  {
    id: 32,
    src: '/img/photogalerie/compressed/IMG_2845.jpeg',
    type: 'image'
  },
  {
    id: 33,
    src: '/img/photogalerie/compressed/IMG_2882.jpeg',
    type: 'image'
  },
  {
    id: 34,
    src: '/img/photogalerie/compressed/IMG_2885.jpeg',
    type: 'image'
  },
  {
    id: 35,
    src: '/img/photogalerie/compressed/IMG_2920.jpeg',
    type: 'image'
  },
  {
    id: 36,
    src: '/img/photogalerie/compressed/IMG_2940.jpeg',
    type: 'image'
  },
  {
    id: 37,
    src: '/img/photogalerie/compressed/IMG_2956.jpeg',
    type: 'image'
  },
  {
    id: 38,
    src: '/img/photogalerie/compressed/IMG_2959.mp4',
    type: 'video'
  },
  {
    id: 39,
    src: '/img/photogalerie/compressed/IMG_5653.jpeg',
    type: 'image'
  },
  {
    id: 40,
    src: '/img/photogalerie/compressed/IMG_5665.mp4',
    type: 'video'
  },
  {
    id: 41,
    src: '/img/photogalerie/compressed/IMG_5696.jpeg',
    type: 'image'
  },
  {
    id: 42,
    src: '/img/photogalerie/compressed/IMG_5698.jpeg',
    type: 'image'
  },
  {
    id: 43,
    src: '/img/photogalerie/compressed/IMG_5730.jpeg',
    type: 'image'
  },
  {
    id: 44,
    src: '/img/photogalerie/compressed/IMG_5735.jpeg',
    type: 'image'
  },
  {
    id: 45,
    src: '/img/photogalerie/compressed/IMG_5750.jpeg',
    type: 'image'
  },
  {
    id: 46,
    src: '/img/photogalerie/compressed/IMG_5760.jpeg',
    type: 'image'
  },
  {
    id: 47,
    src: '/img/photogalerie/compressed/IMG_5837.jpeg',
    type: 'image'
  },
  {
    id: 48,
    src: '/img/photogalerie/compressed/IMG_5847.jpeg',
    type: 'image'
  },
  {
    id: 49,
    src: '/img/photogalerie/compressed/IMG_5863.mp4',
    type: 'video'
  },
  {
    id: 50,
    src: '/img/photogalerie/compressed/IMG_5866.mp4',
    type: 'video'
  },
  {
    id: 51,
    src: '/img/photogalerie/compressed/IMG_5872.jpeg',
    type: 'image'
  },
  {
    id: 52,
    src: '/img/photogalerie/compressed/IMG_5874.jpeg',
    type: 'image'
  },
  {
    id: 53,
    src: '/img/photogalerie/compressed/IMG_5937.jpeg',
    type: 'image'
  },
  {
    id: 54,
    src: '/img/photogalerie/compressed/IMG_5961.jpeg',
    type: 'image'
  },
  {
    id: 55,
    src: '/img/photogalerie/compressed/IMG_5963.jpeg',
    type: 'image'
  },
  {
    id: 56,
    src: '/img/photogalerie/compressed/IMG_8971.jpeg',
    type: 'image'
  },
  {
    id: 57,
    src: '/img/photogalerie/compressed/IMG_8976.jpeg',
    type: 'image'
  },
  {
    id: 59,
    src: '/img/photogalerie/compressed/IMG_9058.jpeg',
    type: 'image'
  },
  {
    id: 60,
    src: '/img/photogalerie/compressed/IMG_9075.jpeg',
    type: 'image'
  },
  {
    id: 62,
    src: '/img/photogalerie/compressed/IMG_9115.png',
    type: 'image'
  },
  {
    id: 63,
    src: '/img/photogalerie/compressed/IMG_9135.png',
    type: 'image'
  },
  {
    id: 64,
    src: '/img/photogalerie/compressed/IMG_9148.png',
    type: 'image'
  },
  {
    id: 65,
    src: '/img/photogalerie/compressed/IMG_9158.png',
    type: 'image'
  },
  {
    id: 66,
    src: '/img/photogalerie/compressed/IMG_9240.png',
    type: 'image'
  },
  {
    id: 67,
    src: '/img/photogalerie/compressed/IMG_9352.png',
    type: 'image'
  },
  {
    id: 68,
    src: '/img/photogalerie/compressed/IMG_9637.png',
    type: 'image'
  },
  {
    id: 69,
    src: '/img/photogalerie/compressed/IMG_9641.png',
    type: 'image'
  },
  {
    id: 70,
    src: '/img/photogalerie/compressed/IMG_9737.png',
    type: 'image'
  },
  {
    id: 71,
    src: '/img/photogalerie/compressed/IMG_9973.png',
    type: 'image'
  },
];

const Gallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  
  const openModal = (media) => {
    setSelectedMedia(media);
  };
  
  const closeModal = () => {
    setSelectedMedia(null);
  };
  
  return (
    <GalleryContainer>
      <GalleryTitle>Nos souvenirs ensemble, Papa</GalleryTitle>
      <GalleryDescription>
        Papa, voici une collection de nos moments précieux ensemble. Chaque photo et vidéo raconte 
        une histoire de notre complicité et de tous ces instants inoubliables que nous avons partagés.
      </GalleryDescription>
      
      <PhotoGrid>
        {mediaItems.map((media) => (
          <PhotoCard key={media.id} onClick={() => openModal(media)}>
            {media.type === 'image' ? (
              <PhotoImage src={media.src} alt="" />
            ) : (
              <VideoThumbnail>
                <VideoPreview src={media.src} muted />
              </VideoThumbnail>
            )}
          </PhotoCard>
        ))}
      </PhotoGrid>
      
      {selectedMedia && (
        <Modal onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={closeModal}>×</CloseButton>
            {selectedMedia.type === 'image' ? (
              <ModalImage src={selectedMedia.src} alt="" />
            ) : (
              <ModalVideo src={selectedMedia.src} controls autoPlay />
            )}
          </ModalContent>
        </Modal>
      )}
    </GalleryContainer>
  );
};

export default Gallery;
